<div class="active-user-sessions">
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
        [requestInfo]="requestInfo" [headerTemplate]="activeUserHeaderTemplate" [gridContext]="gridContext"
        [(isBusy)]="isGridBusy" [(isBusyMessage)]="isGridBusyMessage" [contextMenuOptions]="contextMenuOptions"
        [pagerVisible]="false" [responseCallback]="responseCallback" isGridWithDurationColumn='true'
        [hasContextMenuPermissions]="hasContextMenuPermissions">
    </res-generic-grid>

    <ng-template #activeUserHeaderTemplate>
        <div class='top-bar-container'>
            <span class="title">Active User Sessions</span>
            <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                (click)="openHelp()">
                <i class="fa fa-question"></i>
            </button>
        </div>
    </ng-template>

</div>